













































import Message from '@/util/MessageWorker';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'FileExport'
})
export default class extends Vue {
  @Prop({ default: false }) private dialogVisible: boolean;
  @Prop({ default: () => [] }) private workFolder: any;

  private pathName = '';
  private pathInputDisable = true;
  private folderInfo = {
    path: '',
    directories: []
  };

  private folderName = '';

  created() {
    this.folderInfo = this.workFolder;
    this.pathName = this.folderInfo.path;
  }

  get fileVisible() {
    return this.dialogVisible;
  }

  set fileVisible(value) {
    this.$emit('update:dialogVisible', value);
  }

  private handleClose() {
    this.fileVisible = false;
  }

  private editPathHandler() {
    this.pathInputDisable = !this.pathInputDisable;
  }

  private upDirHandler() {
    this.downDirHandler('..');
  }

  private async downDirHandler(dir) {
    const result = await Message.emit('home.setting.setWorkFolderBySub', {
      subDirectory: dir
    });
    const { path, directories } = result;
    this.folderInfo.directories = directories;
    this.pathName = path;
    this.pathInputDisable = true;
  }

  private async exportHandler() {
    await Message.emit('generator.toolbar.exportFile', {
      directory: this.pathName,
      folderName: this.folderName
    });
    this.fileVisible = false;
  }
}
